import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
export function About() {
  return <section id="about" className="relative py-24 bg-[#E8E3DD] overflow-hidden" data-id="element-1">
      {/* Serene morning atmosphere */}
      <div className="absolute top-0 left-0 w-full h-full opacity-30" data-id="element-2">
        <div className="absolute top-[10%] right-[20%] w-64 h-64 bg-gradient-to-br from-[#FFE5B4]/30 to-transparent rounded-full blur-3xl" data-id="element-3" />
        <div className="absolute bottom-[20%] left-[10%] w-80 h-80 bg-gradient-to-tr from-[#D4AF37]/20 to-transparent rounded-full blur-3xl" data-id="element-4" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6" data-id="element-5">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-6">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-7">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden relative shadow-xl" data-id="element-8">
              {/* Main Image */}
              <img src="https://images.unsplash.com/photo-1510972527921-ce03766a1cf1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="A calming breakfast tray with coffee and a saucer" className="absolute inset-0 w-full h-full object-cover" data-id="element-9" />

              {/* Subtle overlay to ensure the quote pops */}
              <div className="absolute inset-0 bg-black/10" data-id="element-10" />

              {/* Decorative morning light leak overlay */}
              <div className="absolute top-0 right-0 w-full h-full bg-gradient-to-sw from-[#FFE5B4]/20 to-transparent opacity-50" data-id="element-11" />

              {/* Quote Card */}
              <div className="absolute bottom-8 left-8 right-8 p-6 bg-white/90 backdrop-blur-md rounded-xl shadow-sm" data-id="element-12">
                <p className="text-[#2D3748] font-medium italic" data-id="element-13">
                  "A moment of stillness before the movement of the day."
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-14">
            <div className="flex items-center gap-2 mb-4" data-id="element-15">
              <Heart className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} data-id="element-16" />
              <span className="text-[#D4AF37] font-medium tracking-wider text-sm uppercase" data-id="element-17">
                Our Philosophy
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#2D3748] mb-8 leading-tight" data-id="element-18">
              Bringing calm to the morning rush.
            </h2>
            <div className="space-y-6 text-lg text-[#2D3748]/80 leading-relaxed" data-id="element-19">
              <p data-id="element-20">
                We believe that how you start your morning sets the tone for the
                entire day. That's why we've dedicated ourselves to the art of
                breakfast catering.
              </p>
              <p data-id="element-21">
                Founded in 2023, Grounded Mornings moves away from the standard
                boxed bagels and lukewarm coffee. We bring chef-driven,
                nutritious, and aesthetically pleasing breakfast spreads to
                offices and events.
              </p>
              <p data-id="element-22">
                Our ingredients are sourced from local farms, our coffee is
                roasted in small batches, and our service is designed to be
                invisible yet impeccable.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-3 gap-6" data-id="element-23">
              <div data-id="element-24">
                <h4 className="text-3xl font-bold text-[#2D3748] mb-1" data-id="element-25">100s</h4>
                <p className="text-sm text-[#2D3748]/60" data-id="element-26">of meals elevated</p>
              </div>
              <div data-id="element-27">
                <h4 className="text-3xl font-bold text-[#2D3748] mb-1" data-id="element-28">
                  1000s
                </h4>
                <p className="text-sm text-[#2D3748]/60" data-id="element-29">of moments grounded</p>
              </div>
              <div data-id="element-30">
                <h4 className="text-3xl font-bold text-[#2D3748] mb-1" data-id="element-31">100%</h4>
                <p className="text-sm text-[#2D3748]/60" data-id="element-32">locally sourced</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}